/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Bühler
 * Date: 22.03.2016
 *
 */

import { ClassNames as MapClassNames } from 'plugin/map-portlet';
import { AdministrativeRank } from './Constants';

const getVectorFeatureGroupStyle = function (properties, zoom){
    const stateColors = {
        unknown: '#676a6c',
        green: '#79e14b',
        yellow: '#ffe700',
        orange: '#ffad00',
        red: '#f00000',
    };

    var state = properties.overallState;
    let fillColor = stateColors[state];
    return {
        weight: 2,
        radius: 4,
        fillColor,
        fillOpacity: 0.4,
        fill: true
    };
}

export const FliwasOrganizationsAllLayer = {
    id: 'fliwas_organizations',
    uuid: 'fliwas_organizations',
    title: 'Mandaten',
    className: 'Group',
    api: "FliwasOrganizationWebApi",
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-vector-layer',
    params: {},
    config: {
        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
        filter: {
            'type': 'Group'
        },
        style: {
            color: '#326487',
            fillColor: '#68869B',
        },
        vectorTileLayerStyles: {
            default: getVectorFeatureGroupStyle
        }
    }
};

export const FliwasOrganizationsRpLayer = {
    id: 'fliwas_organizations_rp',
    uuid: 'fliwas_organizations_rp',
    title: 'Mandaten',
    className: 'Group',
    api: "FliwasOrganizationWebApi",
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-vector-layer',
    params: {},
    config: {
        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
        filter: {
            'type': 'Group',
            'administrativeRank': AdministrativeRank.RP
        },
        style: {
            color: '#326487',
            fillColor: '#68869B',
        },
        vectorTileLayerStyles: {
            default: getVectorFeatureGroupStyle
        }
    }
};

export const FliwasOrganizationsDistrictLayer = {
    id: 'fliwas_organizations_district',
    uuid: 'fliwas_organizations_district',
    title: 'Mandaten',
    className: 'Group',
    api: "FliwasOrganizationWebApi",
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-vector-layer',
    params: {},
    config: {
        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
        filter: {
            'type': 'Group',
            'administrativeRank': AdministrativeRank.DISTRICT
        },
        style: {
            color: '#326487',
            fillColor: '#68869B',
        },
        vectorTileLayerStyles: {
            default: getVectorFeatureGroupStyle
        }
    }
};

export const FliwasOrganizationsCommuneLayer = {
    id: 'fliwas_organizations_commune',
    uuid: 'fliwas_organizations_commune',
    title: 'Mandaten',
    className: 'Group',
    api: "FliwasOrganizationWebApi",
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-vector-layer',
    params: {},
    config: {
        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
        filter: {
            'type': 'Group',
            'administrativeRank': AdministrativeRank.COMMUNE
        },
        style: {
            color: '#326487',
            fillColor: '#68869B',
        },
        vectorTileLayerStyles: {
            default: getVectorFeatureGroupStyle
        }
    }
};

/*
export const FliwasOrganizationsAllLayer = {
    id: 'fliwas_organizations',
    uuid: 'fliwas_organizations',
    title: 'Mandaten',
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-data-layer',
    params: {},
    config: {
        params: { "classNames": ["Group"] }
    }
};
export const FliwasOrganizationsRpLayer = {
    id: 'fliwas_organizations_rp',
    uuid: 'fliwas_organizations_rp',
    title: 'Mandaten',
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-data-layer',
    params: {},
    config: {
        params: {
            "classNames": ["Group"],
            "administrativeRank": AdministrativeRank.RP
        }
    }
};

export const FliwasOrganizationsDistrictLayer = {
    id: 'fliwas_organizations_district',
    uuid: 'fliwas_organizations_district',
    title: 'Mandaten',
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-data-layer',
    params: {},
    config: {
        params: {
            "classNames": ["Group"],
            "administrativeRank": AdministrativeRank.DISTRICT
        }
    }
};

export const FliwasOrganizationsCommuneLayer = {
    id: 'fliwas_organizations_commune',
    uuid: 'fliwas_organizations_commune',
    title: 'Mandaten',
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-data-layer',
    params: {},
    config: {
        params: {
            "classNames": ["Group"],
            "administrativeRank": AdministrativeRank.COMMUNE
        }
    }
};*/




// WEBPACK FOOTER //
// ./js/constants/MapLayer.js